<template>
    <v-card outlined>
        <div class="cyan accent-4 white--text pa-4">
            <div class="body-2 font-weight-medium">
                <v-icon small color="white" left @click="$emit('cancel')">fa-arrow-left</v-icon>
                <span style="opacity:.7">My goals in {{lapse}} years</span>
            </div>

            <div class="pl-5 my-1">
                <v-divider></v-divider>
            </div>

            <div class="ml-5">
                <div class="caption font-weight-medium">GOAL TRACKING: EDIT RESOURCES</div>
                <div class="title mt-n1">
                    <v-icon size="12px" color="white" class="mr-1 ml-1">fa-minus</v-icon>
                    {{goal.item.goal}}
                </div>
            </div>
        </div>

        <v-card-text class="pt-3 px-6 pb-7" v-if="loaded">
            <div class="body-2 font-weight-medium grey--text text--darken-3 mt-4 mb-8">
                Resources I <span style="text-decoration: underline">do not have</span> to accomplish my goal:
            </div>

            <!-- 1 -->
            <v-text-field
                v-model="model['g'+goal.index][0]"
                label="1."
                outlined dense
                maxlength="60"
                @keydown.enter="save"
                class="mt-4">
                <template v-slot:prepend>
                    <v-icon color="cyan accent-4" class="mt-1 mr-1" small>fa-magic fa-fw</v-icon>
                </template>
            </v-text-field>

            <!-- 2 -->
            <v-text-field
                v-model="model['g'+goal.index][1]"
                label="2."
                outlined dense
                maxlength="60"
                @keydown.enter="save"
                class="mt-4">
                <template v-slot:prepend>
                    <v-icon color="cyan accent-4" class="mt-1 mr-1" small>fa-magic fa-fw</v-icon>
                </template>
            </v-text-field>

            <!-- 3 -->
            <v-text-field
                v-model="model['g'+goal.index][2]"
                label="3."
                outlined dense
                maxlength="60"
                @keydown.enter="save"
                class="mt-4">
                <template v-slot:prepend>
                    <v-icon color="cyan accent-4" class="mt-1 mr-1" small>fa-magic fa-fw</v-icon>
                </template>
            </v-text-field>

            <v-divider></v-divider>

            <div class="d-flex align-center justify-center ml-10 mt-3">
                <v-icon size="10" color="cyan accent-4" class="mr-2">fa-exclamation-triangle</v-icon>
                <div class="caption">You can always come back later to edit it.</div>
            </div>

            <div class="text-center mt-6">
                <v-btn text class="grey--text text--darken-1 mr-2" @click="$emit('cancel')">Cancel</v-btn>
                <v-btn depressed large class="cyan accent-4 white--text" @click="save" :disabled="sending">Save</v-btn>
            </div>

        </v-card-text>
    </v-card>
</template>

<script>
import Helpers from '@/services/helpers'
import Personal from '@/firebase/personal'

export default {
    data: () => ({
        loaded: false,
        sending: false,
        model: {}
    }),
    props: ['goals','lapse', 'goal'],
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.model['g'+this.goal.index] = ['', '', ''];

            if (this.goals['t'+this.lapse].resourcesNo) {
                _.merge(this.model, this.goals['t'+this.lapse].resourcesNo);
            }

            this.loaded = true;
        },
        prepare() {
            let tempo = [];
            this.model['g'+this.goal.index].forEach( dt => {
                if (!this.validateIsEmpty(dt)) {
                    tempo.push(dt)
                }
            });
            return tempo;
        },
        save() {
            this.sending = true;

            let final = this.prepare();
            let g = JSON.parse(JSON.stringify(this.goals));

            if (g['t'+this.lapse].resourcesNo == undefined) {
                g['t'+this.lapse].resourcesNo = {};
            }

            g['t'+this.lapse].resourcesNo['g'+this.goal.index] = final;

            Personal.updateGoals(this.user.uid, g)
                    .then(response => {
                        if (response === true) {
                            this.$store.dispatch('setGoals', this.model);
                            this.$emit('saved');
                            this.$store.dispatch('setSnack', {kind:'success', text:'Resources has been updated.'});
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'Error.'});
                        }
                        this.sending = false;
                    });
        }
    }
}
</script>

<style scoped>
    a {
        color: white !important;
    }
</style>
